import React from "react"
import IconButton from '@material-ui/core/IconButton';
import SyncIcon from '@material-ui/icons/Sync'
import SyncDisabledIcon from '@material-ui/icons/SyncDisabled'
import SyncProblemIcon from '@material-ui/icons/SyncProblem'
import HourglassEmptyIcon from '@material-ui/icons/HourglassEmpty'
import HelpIcon from '@material-ui/icons/Help'
import DoneIcon from '@material-ui/icons/Done'
import DoneOutlineIcon from '@material-ui/icons/DoneOutline'
import CompareArrowsIcon from '@material-ui/icons/CompareArrows';

import {SYNC_STATE_ERROR, SYNC_STATE_SYNCING, SYNC_STATE_NEEDS_SYNC, SYNC_STATE_NOT_SYNCABLE, SYNC_STATE_SYNCED_PULL, SYNC_STATE_SYNCED_PUSH, SYNC_STATE_NEEDS_DELETE, SYNC_STATE_SYNCED_BOTH} from "redux/constants";

class PassiveIconButton extends React.PureComponent {
  render() {
      return <IconButton style={{cursor:'default'}} {...this.props} ></IconButton>
  }
}

class SyncStatusIcon extends React.PureComponent {
  render() {
    const {syncState, titleExtra='', syncStateDescription=''} = this.props
    const descriptionSuffix = syncStateDescription ? ` (${syncStateDescription})` : ''
    switch (syncState) {
      case SYNC_STATE_SYNCING :
        return <PassiveIconButton title={`Syncing ${titleExtra}${descriptionSuffix}`}><SyncIcon /></PassiveIconButton>
      case SYNC_STATE_NEEDS_SYNC :
        return <PassiveIconButton title={`Needs sync ${titleExtra}${descriptionSuffix}`}><HourglassEmptyIcon /></PassiveIconButton>
      case SYNC_STATE_NEEDS_DELETE :
          return <PassiveIconButton title={`Needs reconcile with Skyward ${titleExtra}${descriptionSuffix}`}><HourglassEmptyIcon /></PassiveIconButton>
      case SYNC_STATE_SYNCED_PULL :
        return <PassiveIconButton title={`Synced PULL ${titleExtra}${descriptionSuffix}`}><DoneOutlineIcon/></PassiveIconButton>
      case SYNC_STATE_SYNCED_PUSH :
        return <PassiveIconButton title={`Synced PUSH ${titleExtra}${descriptionSuffix}`}><DoneIcon/></PassiveIconButton>
      case SYNC_STATE_NOT_SYNCABLE :
        return <PassiveIconButton title={`Not eligible for sync ${titleExtra}${descriptionSuffix}`}><SyncDisabledIcon/></PassiveIconButton>
      case SYNC_STATE_ERROR :
        return <PassiveIconButton title={`Error syncing ${titleExtra}${descriptionSuffix}`}><SyncProblemIcon/></PassiveIconButton>
      case SYNC_STATE_SYNCED_BOTH :
        return <PassiveIconButton title={`Overridden by other attendance ${titleExtra.replace("delinked:", "")}${descriptionSuffix}`}><CompareArrowsIcon/></PassiveIconButton>
      default :
        return <PassiveIconButton title={`Sync state (${syncState})${descriptionSuffix}`}><HelpIcon/></PassiveIconButton>
    }
  }
}

export default SyncStatusIcon